import React from 'react';
import { useTranslation } from 'react-i18next';

export default function StatsBar({ totalCount, highlightedCount, filterMode, onFilterChange }) {
  const { t } = useTranslation();
  const notHighlightedCount = totalCount - highlightedCount;

  const cards = [
    {
      key: 'all',
      label: t('totalData'),
      value: totalCount,
      className: 'stats-card card-total',
    },
    {
      key: 'onlyHighlighted',
      label: t('scanned'),
      value: highlightedCount,
      className: 'stats-card card-highlighted',
    },
    {
      key: 'onlyNotHighlighted',
      label: t('notScanned'),
      value: notHighlightedCount,
      className: 'stats-card card-not-highlighted',
    },
  ];

  return (
    <div className="stats-bar">
      {cards.map((card) => (
        <div
          key={card.key}
          className={`${card.className} ${filterMode === card.key ? 'active-card' : ''}`}
          onClick={() => onFilterChange(card.key)}
        >
          <div className="stat-value">{card.value}</div>
          <div className="stat-label">{card.label}</div>
        </div>
      ))}
    </div>
  );
}
